import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import SelectCulturaReceituario from "../../../../../../../../components/SelectsSimpleApiQuery/SelectCulturaReceituario";
import { useMemo, useState } from "react";
import { CulturaPragaReceituario } from "../../../../../../../../types/api/comercial/pesquisar-cultura-praga-receituario";
import { ICarrinhoItem } from "../..";
import { IReceituarioData } from ".";

export default function DialogReceituario({
    open,
    handleClose,
    itensComReceita,
    onSave
}: DialogReceituarioProps) {

    const [internForm, setInternForm] = useState<InternForm[] | null>(null)

    //Variáveis de controle
    const permiteGerar = useMemo(() => {
        return itensComReceita.every(i => i.emite_receita === "S" && i.agrotoxico_id !== null);
    }, [itensComReceita]);

    const culturasPreenchidas = useMemo(() => {
        if (internForm) {
            return internForm.filter(i => i.cultura_id && i.praga_id).length === itensComReceita.length
        }
        return false
    }, [internForm, itensComReceita])

    // Funções manipuladoras
    const handleChangeReceituario = (value: CulturaPragaReceituario, id: string) => {
        setInternForm((prevState) => {
            if (prevState) {
                const index = prevState.findIndex(i => i.id === id)
                if (index >= 0) {
                    prevState[index] = { ...value, id }
                } else {
                    prevState.push({ ...value, id })
                }
                return [...prevState]
            } else {
                return [{ ...value, id }]
            }
        })
    }

    const handleGerar = () => {
        const params: IReceituarioData = {
            itens: internForm?.map(i => {
                return {
                    item_id: i.id,
                    cultura_id: i.cultura_id ?? 0,
                    praga_id: i.praga_id ?? 0,
                    nome_cultura: i.nome_cultura ?? "",
                    nome_cientifico: i.nome_cientifico ?? ""
                }
            }) ?? [],
        }

        onSave(params)
        handleClose()
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>
                Informar cultura/praga para receituário
            </DialogTitle>

            <DialogContent>
                <TableContainer sx={{ mb: 2 }} >
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ border: 'none' }}><b>Produto</b></TableCell>
                                <TableCell sx={{ border: 'none' }}><b>Cultura/Praga</b></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                itensComReceita.map((item, index) => {
                                    return (
                                        <TableRow key={index}>
                                            <TableCell sx={{ border: 'none' }}>{item.nome}</TableCell>
                                            <TableCell sx={{ border: 'none' }} width={'70%'}>
                                                <SelectCulturaReceituario
                                                    inputLabel="Cultura/Praga"
                                                    value={internForm?.find(i => i.id === item.id) as CulturaPragaReceituario}
                                                    onChangeValue={(e) => { handleChangeReceituario(e, item.id) }}
                                                    agrotoxico_id={item.agrotoxico_id ?? 0}
                                                    disabled={!item.agrotoxico_id}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancelar
                </Button>
                <Button
                    onClick={handleGerar}
                    color="primary"
                    variant="contained"
                    disabled={!permiteGerar || !culturasPreenchidas}
                >
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogReceituarioProps {
    open: boolean;
    handleClose: () => void;
    itensComReceita: ICarrinhoItem[];
    onSave: (data: IReceituarioData) => void;
}

interface InternForm extends CulturaPragaReceituario { id: string }
